import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "footer-left"
};
const _hoisted_2 = {
  class: "footer-right"
};
import global from '../../component-create/utils/global';
import { GLOBAL_DATA } from '../../component-create/utils/global-enum';
import UploadContainer from './UploadContainer.vue';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XDataImport',
  props: {
    action: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: '导入'
    },
    width: {
      type: String,
      default: '30%'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: () => ['.xls', '.xlsx']
    },
    limit: {
      type: Number,
      default: 1
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    templateUrl: {
      type: String,
      default: ''
    },
    resultHandler: Function,
    errorHandler: Function,
    exportBaseUrl: {
      type: String,
      default: ''
    },
    beforeUpload: Function
  },
  emits: ['importStart', 'importEnd', 'importSuccess', 'importError'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const DOWNLOAD = global.globalVal[GLOBAL_DATA.FILE_DOWNLOAD];
    const props = __props;
    const emits = __emit;
    const uploaderContainer = ref();
    const importing = ref(false);
    const template = ref({
      downloading: false
    });
    const result = ref({
      ready: false,
      message: ''
    });
    const diaVisible = ref(false);
    function show() {
      diaVisible.value = true;
    }
    function close() {
      diaVisible.value = false;
    }
    function reset() {
      importing.value = false;
      template.value.downloading = false;
      result.value.ready = false;
      result.value.message = '';
      uploaderContainer.value?.reset();
    }
    function handleImport() {
      uploaderContainer.value?.submit();
    }
    function handleClose() {
      close();
    }
    function handleClosed() {
      reset();
    }
    function handleImportStart() {
      importing.value = true;
      emits('importStart');
    }
    function handleImportEnd() {
      importing.value = false;
      emits('importEnd');
    }
    function handImportError(e) {
      emits('importError', e);
    }
    function handleImportSuccess(res) {
      const sheetImportResults = res.sheetImportResults;
      if (sheetImportResults && sheetImportResults.length > 0) {
        result.value.message = sheetImportResults.flatMap(r => r.sheetName + '：' + r.importCount + '条').join('，');
        result.value.ready = true;
      }
      emits('importSuccess', res);
    }
    function handleDownloadTemplate() {
      downloadTemplate();
    }
    function downloadTemplate() {
      if (template.value.downloading) {
        return;
      }
      let promise = DOWNLOAD(`${props.exportBaseUrl}/template/${encodeURIComponent(props.templateUrl)}`, {});
      template.value.downloading = true;
      if (promise) {
        promise.finally(() => {
          template.value.downloading = false;
        });
      }
    }
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_result = _resolveComponent("el-result");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(diaVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(diaVisible) ? diaVisible.value = $event : null),
        title: __props.title,
        width: __props.width,
        closeable: !_unref(importing),
        onClose: handleClosed
      }, {
        footer: _withCtx(() => [_renderSlot(_ctx.$slots, "footer"), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [__props.templateUrl ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          size: "small",
          type: "primary",
          plain: "",
          round: "",
          loading: _unref(template).downloading,
          onClick: handleDownloadTemplate
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("下载模板文件 ")])),
          _: 1
        }, 8, ["loading"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(importing),
          onClick: handleImport
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("导入")])),
          _: 1
        }, 8, ["loading"])])])]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "custom"), _withDirectives(_createVNode(UploadContainer, _mergeProps({
          ref_key: "uploaderContainer",
          ref: uploaderContainer
        }, _ctx.$props, {
          onImportSuccess: handleImportSuccess,
          onImportStart: handleImportStart,
          onImportEnd: handleImportEnd,
          onImportError: handImportError,
          exportBaseUrl: __props.exportBaseUrl
        }, _toHandlers(_ctx.$attrs)), null, 16, ["exportBaseUrl"]), [[_vShow, !_unref(result).ready]]), _withDirectives(_createVNode(_component_el_result, {
          icon: "success",
          title: "导入成功"
        }, {
          "sub-title": _withCtx(() => [_createTextVNode(_toDisplayString(_unref(result).message), 1)]),
          extra: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: close
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("确定")])),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, _unref(result).ready]])]),
        _: 3
      }, 8, ["modelValue", "title", "width", "closeable"]);
    };
  }
});